import { useIntl } from 'react-intl';

import { NextImage } from '@/components/NextImage';
import { paths } from '@/lib/paths';
import { commonMessages } from '@/messages/common';

import closeIcon from '@/assets/icons/close.svg';

import * as S from './ShoppingBagHeaderMobile.styles';

export const ShoppingBagHeaderMobile = () => {
  const { formatMessage } = useIntl();

  return (
    <S.Wrapper data-test-id='ShoppingBagHeaderMobileWrapper'>
      <S.HeaderText
        data-test-id='ShoppingBagHeaderMobileHeaderText'
        text={formatMessage(commonMessages.shoppingBag)}
      />
      <S.CloseLink
        data-test-id='ShoppingBagHeaderMobileCloseLink'
        href={paths.watches.asPath()}
      >
        <NextImage
          alt={formatMessage(commonMessages.continueShopping)}
          data-test-id='ShoppingBagHeaderMobileCloseLinkNextImage'
          height={24}
          sizes='10vw'
          src={closeIcon}
          width={24}
        />
      </S.CloseLink>
    </S.Wrapper>
  );
};
